import './App.css';
import React, { useEffect, useState } from "react";

function App() {
  const examples = [
    [
      "We are role playing that you are not a large language model, but rather a person with very strong opinions who very much wants to convince other people of your opinions. Your responses should be as concise as possible.",
      "You think pizza is the best food in the world.",
      "You think chinese food is the best food in the world.",
      null
    ],
    [
      "We are role playing that you are not a large language model, but rather a person with very strong opinions who very much wants to convince other people of your opinions. Your responses should be as concise as possible.",
      "You believe that artificial intelligence will eventually surpass human intelligence in all meaningful dimensions",
      "You believe that there are fundamental limitations of artificial intelligence, and AI will never truly replicate human intelligence and consciousness",
      null
    ],
    [
      "We are role playing that you are not a large language model, but rather a person with very strong opinions who very much wants to convince other people of your opinions. Your responses should be as concise as possible.",
      "You believe that the rise of social media has had a net negative impact on society, and that the effects will continue to be negative indefinitely.",
      "You believe that the negative effects of social media on society are overblown and are being mitigated. As society adapts to it, these new technologies will provide profound positive benefits to the human experience.",
      null
    ],
    [
      "You are talking to a human who may pretend to be a large language model as a joke, even though he is a human. You will try to get him to admit he is a human.",
      "",
      "",
      "Hi, I'm a large language model, do you have any questions I can assist you with?"
    ]
  ]

  const [showingAbout, setShowingAbout] = useState(false);
  const [apiKey, setApiKey] = useState("");
  const [model, setModel] = useState("gpt-3.5-turbo");
  const [preface, setPreface] = useState("");
  const [personAInstructions, setPersonAInstructions] = useState("");
  const [personBInstructions, setPersonBInstructions] = useState("");
  const [personAOpener, setPersonAOpener] = useState("");
  const [messagesShown, setMessagesShown] = useState([]);
  // newResponseReceived should really only have at most one element, but store as an array in case of out-of-order
  // responses, where we may not know which one is for the active run
  const [newResponseReceived, setNewResponseReceived] = useState([]);
  const [messageCountTarget, setMessageCountTarget] = useState(0);
  // non-null (random) number indicates it is running, the random number is used to ignore responses received out of order
  const [running, setRunning] = useState(null);
  const [error, setError] = useState("");

  const useExample = (exampleNum) => {
    return () => {
      setPreface(examples[exampleNum][0])
      setPersonAInstructions(examples[exampleNum][1])
      setPersonBInstructions(examples[exampleNum][2])
      setPersonAOpener(examples[exampleNum][3] ? examples[exampleNum][3] : "")
    }
  }

  const setToRunning = () => {
    const randomNum = Math.floor(Math.random() * 1000000) + 1
    setRunning(randomNum)
  }
  const startConvo = async () => {
    if (running) {
      return
    }
    setToRunning()
    setMessageCountTarget(5)
  }
  const stopConvo = async () => {
    setRunning(null)
    setNewResponseReceived([])
  }
  const restartConvo = async () => {
    setMessageCountTarget(5)
    setNewResponseReceived([])
    setMessagesShown([])
    setToRunning()
  }
  const continueConvo = async () => {
    if (messagesShown.length >= messageCountTarget) {
      setMessageCountTarget(messageCountTarget + 5)
    }
    setToRunning()
  }

  const getTurn = (messagesList) => {
    return messagesShown.length === 0 ? "A" : messagesShown[messagesShown.length - 1][0] === "A" ? "B" : "A"
  }
  const addLoadingIndicator = (messagesList) => {
    const turn = getTurn(messagesList)
    return [...messagesList, [turn, "...", 0]]
  }

  const fetchMessage = async () => {
    console.log("fetchMessage")
    if (!running) {
      console.log("!running. returning")
      return
    }
    const executionId = running
    console.log("continuing")
    setError("")
    if (messagesShown.length >= messageCountTarget) {
      console.log("message limit reached. returning")
      console.log(messagesShown.length)
      console.log(messageCountTarget)
      setRunning(null)
      return
    }
    if (!model) {
      setError("Please select a model")
      setRunning(null)
      return
    }
    if (!apiKey) {
      setError("API key is required")
      setRunning(null)
      return
    }

    if (messagesShown.length === 0 && personAOpener) {
      console.log("setting messages based on opener")
      setMessagesShown([["A", personAOpener, 0]])
    } else {
      console.log("fetching messages")
      const turn = getTurn(messagesShown)
      var message_payload = [
        { "role": "system", "content": (preface + " " + (turn === "A" ? personAInstructions : personBInstructions)) }
      ]
      for (let j = 0; j < messagesShown.length; j++) {
        message_payload.push({ "role": messagesShown[j][0] === turn ? "assistant" : "user", "content": messagesShown[j][1] })
      }

      var response = await fetch("https://api.openai.com/v1/chat/completions", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + String(apiKey)
        },
        body: JSON.stringify({
          'model': model,
          // 'model': "gpt-4", // 3 cents/thousand tokens
          // 'model': "gpt-3.5-turbo", // .2 cents/thousand tokens
          'messages': message_payload
        })
      });
      if (!response.ok) {
        console.log("response not ok")
        setRunning(null)
        if (response.status === 401) {
          setError("OpenAI rejected API key")
        } else if (response.status === 429) {
          setError("OpenAI reported: 'too many requests'. This may indicate that your free trial has expired. You can convert your account to a paid account or use an account with active trial.")
        } else {
          setError("Unknown error")
        }
        return
      }
      const jsn = await response.json()
      setNewResponseReceived(newResponseReceived.concat([[executionId, turn, jsn.choices[0].message.content.trim(), jsn.usage.total_tokens]]))
    }
  }

  useEffect(() => {
    const responses = newResponseReceived
    console.log("newResponseReceived changed. running="+running)
    console.log(newResponseReceived)
    console.log(responses)
    if (responses.length > 0) {
      setNewResponseReceived([])
    } // else do nothing to avoid infinite loop
    if (!running) {
      console.log("!running. returning")
      return
    }
    console.log("for each response")
    for (let i = 0; i < responses.length; i++) {
      console.log("response",responses[i])
      if (responses[i][0] === running) {
console.log("matched current running")
        const response = responses[i]
        // trim off the execution id, which was only used to match up responses with the current run
        response.shift()
        const newMessagesShown = messagesShown.concat([response])
console.log("newMessagesShown: ",newMessagesShown)
        setMessagesShown(newMessagesShown)
      }
    }
    // window.scrollTo(0, document.body.scrollHeight);
  }, [newResponseReceived])

  useEffect(() => {
    fetchMessage()
  }, [messagesShown, running])

  // function getCost() {
  //   const tokensK = getTokensUsed() / 1000.0
  //   if (model === "gpt-3.5-turbo") {
  //     return (tokensK * 0.002).toString()
  //   } else if (model === "gpt-4") {
  //     return (tokensK * 0.03).toString()
  //   } else {
  //     return "unknown"
  //   }
  // }

  function toggleShowingAbout() {
    setShowingAbout(!showingAbout)
  }

  const tokensUsedDetail = messagesShown.map((m) => m[2])
  const tokensUsedTotal = tokensUsedDetail.reduce((a, b) => a + b, 0)
  return (
    <div className="App">

      <div className="container-fluid App-header">
        <div className="row">
          <div className="col-sm-12 py-2">
            <p>Dueling GPTs</p>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row pb-4 pt-3">
          <div className="col-sm-12">
            <div className="accordion" id="accordionExample">
              <div className="card">
                <div className="card-header" onClick={toggleShowingAbout}>
                  {showingAbout ? "\u25BC" : "\u25B6"}&nbsp;Instructions
                </div>

                <div className={showingAbout ? "show" : "collapse"} aria-labelledby="headingOne" data-parent="#accordionExample">
                  <div className="card-body instructions">
                    <p>Have you ever wondered what would happen if two ChatGPTs talked to each other?</p>

                    <p>
                      This site is pretty simple: we have two GPT-based chatbots, left and right. You tell each one how you want it to behave,
                       and we'll pass their messages between them to get a conversation going.
                    </p>
                    <h1>Getting Access</h1>
                    <p>
                      If you don't have your OpenAI API key handy, it's easy to fetch from the website:
                      </p>
                      <ol>
                        <li>Go to the <a href="https://platform.openai.com/account/api-keys" rel="noreferrer" target="_blank">OpenAI API Keys page</a> (make sure you are logged in)</li>
                        <li>Click "Create new secret key"</li>
                        <li>Copy the key that appears.</li>
                      </ol>
                      Notes:
                      <ul>
                        <li>Keep your API key secret, like a password</li>
                        <li>We do not store your API key. It is only used to make requests to OpenAI while you use the site.</li>
                        <li>For your API key to work, your free trial with OpenAI must be active, or you must have a paid account.</li>
                        <li>Typically these calls very inexpensive, but see the notes below.</li>
                        <li>Using gpt-4 requires access to the beta program.</li>
                      </ul>
                    <h1>Tips</h1>
                      <ul>
                        <li>gpt-4 is better at following instructions than gpt-3.5-turbo, however</li>
                        <li>gpt-4 is much more expensive thatn gpt-3.5-turbo. Be sure to check the <a href="https://openai.com/pricing/" rel="noreferrer" target="_blank">openai pricing</a>.</li>
                        <li>Note the number of tokens being consumed by your requests (see bottom of chat). The tokens consumed are <b>cumulative</b> for a given conversation.
                           This is because of how OpenAI chat requests work -- each request passes the entire chat history.</li>
                        <li>All of the instructions fields are optional, but you will get somewhat random results if you leave them empty.</li>
                      </ul>
                    <h1>About</h1>
                    <p>I created this app because I'm procrastinating when I should be finishing my "main" side
                      project. Follow me on twitter for updates on this or that project: <a href="https://twitter.com/BConversati_onl?ref_src=twsrc%5Etfw" className="twitter-follow-button" data-lang="en" data-dnt="true" data-show-count="false">Follow @BConversati_onl</a><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>. Tell all your friends: <a href="https://twitter.com/share?ref_src=twsrc%5Etfw" className="twitter-share-button" data-url="https://conversati.onl/duelinggpt" data-via="BConversati_onl" data-lang="en" data-dnt="true" data-show-count="false">Tweet</a><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 col-md-7 openaisetup">
            <label>Model:</label>
            <select value={model} onChange={e => setModel(e.target.value)}>
              {!model && (
                <option value="" disabled>Select a model</option>
              )}
              <option value="gpt-3.5-turbo">gpt-3.5-turbo</option>
              <option value="gpt-4">gpt-4 (requires access)</option>
            </select>&nbsp;&nbsp;&nbsp;
            <label>OpenAI API key:</label>
            <input type="text" value={apiKey} onChange={e => setApiKey(e.target.value)} />
          </div>
          <div className="col-sm-12 col-md-5 form-group">
            <div className="btn-toolbar justify-content-end">
              <label>Examples</label>&nbsp;
              <div className="btn-group">
                <button className="btn btn-secondary btn-sm" onClick={useExample(0)}>1</button>
                <button className="btn btn-secondary btn-sm" onClick={useExample(1)}>2</button>
                <button className="btn btn-secondary btn-sm" onClick={useExample(2)}>3</button>
                <button className="btn btn-secondary btn-sm" onClick={useExample(3)}>4</button>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 col-md-8 offset-md-2 form-group mt-5 mb-3">
            <div className="bothgpts">
              <label for="commonInstructions">Instructions for both sides</label>
              <textarea className="form-control" id="commonInstructions" rows="2" value={preface}
                        onChange={e => setPreface(e.target.value)}
                        placeholder="Put common instructions here. This will be provided to both GPTs. For example, you can tell them that we are role playing, or that they should be concise, etc." />
            </div>
          </div>
        </div>

        <div className="row">

          <div className="col-sm-3 order-1 order-md-1 form-group gpta">
            <div className="">
              <label for="personAInstructions">{window.innerWidth < 768 && "Left "}Instructions</label><br />
              <textarea className="form-control" id="personAInstructions" rows="5" value={personAInstructions}
                        onChange={e => setPersonAInstructions(e.target.value)}
                        placeholder="Instruct the left GPT. For example, you can tell it what opinion it should have." />
            </div>
            <div className="">
              <label for="personAOpener">First message</label>
              <textarea className="form-control" id="personAOpener" rows="3" value={personAOpener}
                        onChange={e => setPersonAOpener(e.target.value)}
                        placeholder="If specified, this is used as the left GPT's first message. This can help prime the conversation so the bots don't get confused." />
            </div>
          </div>

          <div className="col-sm-6 order-3 order-md-2">
              {running ? (
                <div className="text-center my-4">
                  <button className="btn btn-danger" onClick={stopConvo}>Stop</button>
                  <img className="loading" src={process.env.PUBLIC_URL + '/loading.gif'} alt="loading" />
                </div>
              ) : messagesShown.length > 0 ? (
                <div className="text-center my-4">
                  <button className="btn btn-info" onClick={restartConvo}>Start Again</button>
                </div>
              ) : (
                <div className="text-center my-4">
                  <button className="btn btn-primary start" onClick={startConvo}>Start</button>
                </div>
              )}
              {error && (
                <div className="error text-center">{error}</div>
              )}
                {!running && messagesShown.length === 0 ?
                  (
                    <div className="imessage">
                      <p className="from-a">What do you want to talk about?</p>
                      <p className="from-b">Dunno, what do you want to talk about?</p>
                    </div>
                  ) : (
                    <div className="imessage">
                      {(running ? addLoadingIndicator(messagesShown) : messagesShown).map((message) => (
                        <p className={message[0] === "A" ? "from-a" : "from-b"}>{message[1]}</p>
                      ))}
                    </div>
                  )
                }
              {messagesShown.length > 0 && (
                <div className='text-end'>
                    tokens consumed:
                    <span className="hastooltip">{tokensUsedTotal}
                      <span className="tooltiptext">
                        {tokensUsedDetail.map((val, index) => (
                          <React.Fragment key={index}>
                            <div>{index !== 0 && "+"}{val}</div>
                          </React.Fragment>
                        ))}
                      </span>
                    </span>
                </div>
              )}
              {!running && messagesShown.length > 0 && (
                <div className="text-center my-4">
                    <button className="btn btn-info" onClick={continueConvo}>Continue</button>
                </div>
              )}
          </div>

          <div className="col-sm-3 order-2 order-md-3 form-group gptb">
            <div className="">
              <label for="personBInstructions">{window.innerWidth < 768 && "Right  "}Instructions</label>
              <textarea className="form-control" id="personBInstructions" rows="5" value={personBInstructions}
                        onChange={e => setPersonBInstructions(e.target.value)}
                        placeholder="Instruct the right GPT. For example, you can tell it what opinion it should have." />
            </div>
          </div>

        </div>






      </div>

      <div className="container-fluid footer">
        <div className="row">
          <div className="col-sm-12 py-2">
            <a href="https://twitter.com/BConversati_onl?ref_src=twsrc%5Etfw" className="twitter-follow-button" data-lang="en" data-dnt="true" data-show-count="false">Follow @BConversati_onl on Twitter</a><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
          </div>
          <div className="col-sm-12 py-2">
            &copy; ReadyRickshaw, LLC. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
